var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [
              _c("span", { staticStyle: { color: "#417ced" } }, [
                _vm._v("出库管理"),
              ]),
            ]),
            _c("el-breadcrumb-item", [_vm._v("内部出库")]),
          ],
          1
        ),
        !_vm.is_null(_vm.tableData)
          ? _c(
              "div",
              { staticClass: "money", staticStyle: { "margin-top": "15px" } },
              [
                _vm._m(0),
                _c("div", { staticClass: "contentTotal" }, [
                  _c("p", [
                    _c("span", [
                      _vm._v(
                        "已收金额：￥" + _vm._s(_vm.tableData.receivedMoney)
                      ),
                    ]),
                  ]),
                  _c("p", [
                    _c("span", [
                      _vm._v(
                        "待收金额：￥" + _vm._s(_vm.tableData.awaitIncomeMoney)
                      ),
                    ]),
                  ]),
                  _c("p", [
                    _c("span", [
                      _vm._v("总金额：￥" + _vm._s(_vm.tableData.total)),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _c("div", { staticClass: "state" }, [
          !_vm.is_null(_vm.tableData)
            ? _c("p", { staticClass: "header" }, [
                _vm._v(
                  " 订单状态：" +
                    _vm._s(_vm.orderType[_vm.tableData.orderStatus - 1]) +
                    " "
                ),
              ])
            : _vm._e(),
          _c("ul", [
            _c("li", [
              _c("p", [_vm._v("制单人: " + _vm._s(_vm.tableData.createdName))]),
              _c("p", [
                _vm._v("部门名称: " + _vm._s(_vm.tableData.consigneeDepaName)),
              ]),
              _c("p", [_vm._v("出库类型: " + _vm._s(_vm.tableData.typeName))]),
            ]),
            _c("li", [
              _c("p", [
                _vm._v(
                  "下单时间: " + _vm._s(_vm.$moment(_vm.tableData.createdTime))
                ),
              ]),
              _c("p", [_vm._v("订单编号: " + _vm._s(_vm.tableData.orderId))]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "address" }, [
          _c("p", { staticClass: "header" }, [_vm._v("收货人信息")]),
          _c("ul", [
            _vm.tableData
              ? _c("li", [
                  _c("p", [
                    _vm._v("收货人姓名: " + _vm._s(_vm.tableData.consignee)),
                  ]),
                  _c("p", [
                    _vm._v("联系电话: " + _vm._s(_vm.tableData.receivingPhone)),
                  ]),
                  _c("p", [
                    _vm._v(
                      "收货地址: " +
                        _vm._s(
                          _vm.tableData.address + _vm.tableData.addressDetails
                        )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.tableData
              ? _c("li", [
                  _c("p", [_vm._v("备注: " + _vm._s(_vm.tableData.comment))]),
                ])
              : _vm._e(),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "orderBox" },
          [
            _c("p", { staticClass: "header" }, [_vm._v("订单商品")]),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData.interiorOrderCommodities },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "commodityName", label: "商品名称" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "number", label: "商品数量", width: "180" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "price", label: "商品单价" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "brandName", label: "商品品牌" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "classifyName", label: "商品分类" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "specificationName", label: "商品规格" },
                }),
                _c("el-table-column", {
                  attrs: { label: "商品小计" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.price * scope.row.number) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData.interiorOrderComplimentaries },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "complimentaryName", label: "赠品名称" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "number", label: "赠品数量", width: "180" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "price", label: "赠品单价" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "brandName", label: "赠品品牌" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "classifyName", label: "赠品分类" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "specificationName", label: "赠品规格" },
                }),
                _c("el-table-column", {
                  attrs: { label: "赠品小计" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.price * scope.row.number) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "total" }, [
          _vm.tableData
            ? _c("p", [_vm._v("总计：共 " + _vm._s(_vm.count()) + " 件")])
            : _vm._e(),
          _vm.tableData
            ? _c("p", [
                _vm._v(
                  " 运费：" +
                    _vm._s(_vm.tableData.charge ? _vm.tableData.charge : 0) +
                    " "
                ),
              ])
            : _vm._e(),
          _vm.tableData
            ? _c("p", [_vm._v("总价：" + _vm._s(_vm.tableData.money))])
            : _vm._e(),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "oldOrder" },
      [
        _c("div", { staticClass: "title" }, [_vm._v(" 关联异常单号 ")]),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData.returnGoodsDetailResponses },
          },
          [
            _c("el-table-column", {
              attrs: { type: "expand" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(" 商品 "),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            border: "",
                            data: scope.row.orderReturnCommodityList,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "图片" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                        },
                                        attrs: {
                                          src: _vm.img(scope.row.image),
                                          fit: "cover",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "brandName", label: "品牌" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "name", label: "商品名称" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "number", label: "商品数量" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "price", label: "单价" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "规格", prop: "specificationName" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "total", label: "商品小计" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" 赠品 "),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            border: "",
                            data: scope.row.orderReturnComplimentaryList,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "图片" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                        },
                                        attrs: {
                                          src: _vm.img(scope.row.image),
                                          fit: "cover",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "brandName", label: "品牌" },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "complimentaryName",
                              label: "商品名称",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "number", label: "商品数量" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "price", label: "单价" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "规格", prop: "specificationName" },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "total", label: "商品小计" },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "returnOrderId", label: "订单编号" },
            }),
            _c("el-table-column", {
              attrs: { prop: "customerName", label: "客户" },
            }),
            _c("el-table-column", {
              attrs: { prop: "applyName", label: "客服" },
            }),
            _c("el-table-column", {
              attrs: { prop: "orderType", label: "订单状态" },
            }),
            _c("el-table-column", {
              attrs: { prop: "returnMoney", label: "金额" },
            }),
            _c("el-table-column", {
              attrs: { label: "包裹单号" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(" " + _vm._s(scope.row.parcelNumber) + " ")]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "收货信息" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [_vm._v(_vm._s(scope.row.addressName))]),
                      _c("span", [
                        _vm._v(" " + _vm._s(scope.row.addressPhone) + " "),
                      ]),
                      _c("span", [_vm._v(" " + _vm._s(scope.row.address))]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "applyTime", label: "下单时间" },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "headerNav" }, [
      _c("span", [_vm._v("金额状态")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }